import { useLegalProcessDocumentQuery } from "./hooks/useLegalProcessDocumentQuery";
import { useLegalProcessDocumentCommand } from "./hooks/useLegalProcessDocumentCommand";

import Table from "../../common/components/Table";
import IconButton from "../../common/components/IconButton";
import Pagination from "../../common/components/Pagination";
import { DateUtil } from "../../common/utils/date.util";
import { ROUTES } from "../../core/routes/routes";
import { useNavigate } from "react-router-dom";
import { BsClipboardPlus, BsFillTrashFill } from "react-icons/bs";
import { useRef } from "react";
import { RiFileEditFill } from "react-icons/ri";

const columns = (onDelete, onEdit) => [
  {
    header: "Fecha siniestro",
    accessor: "dateAccident",
    render: (value) => DateUtil.format(value, "DD/MM/YYYY"),
  },
  { header: "Nombre implicado", accessor: "namePersonInvolved" },
  { header: "Documento del implicado", accessor: "documentPersonInvolved" },
  { header: "Placa del vehículo", accessor: "vehiclePlate" },
  { header: "Lugar del siniestro", accessor: "placeOfEvent" },
  {
    header: "Documentos",
    accessor: "documents",
    render: (value) => (
      <div className="d-flex flex-column gap-2">
        {value.map((doc, index) => (
          <div key={doc.id} className="d-flex align-items-center gap-2">
            <a href={doc.document} target="_blank" rel="noreferrer">
              Documento {index + 1}
            </a>
            <button
              className="btn btn-sm btn-outline-primary p-1"
              title="Editar documento"
              onClick={() => onEdit(doc.id)}
            >
              <RiFileEditFill size={14} />
            </button>
            <button
              className="btn btn-sm btn-outline-danger p-1"
              title="Eliminar documento"
              onClick={() => onDelete(doc.id)}
            >
              <BsFillTrashFill size={14} />
            </button>
          </div>
        ))}
      </div>
    ),
  },
];

function Indicators() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const editDocIdRef = useRef(null);

  const { documents, loading, totalPages, page, onChangePage, refresh } =
    useLegalProcessDocumentQuery();
  const { deleteLegalProcessDocument, updateLegalProcessDocument } =
    useLegalProcessDocumentCommand(refresh);

  const handleDelete = (docId) => {
    deleteLegalProcessDocument(docId);
  };

  const handleEdit = (docId) => {
    editDocIdRef.current = docId;
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && editDocIdRef.current) {
      updateLegalProcessDocument(editDocIdRef.current, file);
    }
    e.target.value = "";
    editDocIdRef.current = null;
  };

  return (
    <main className="container-fluid p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Documentos de procesos jurídicos</h1>
        <div className="d-flex gap-2">
          <IconButton
            tooltipText="Registrar documento"
            onClick={() => navigate(ROUTES.REGISTER_LEGAL_PROCESS_DOCUMENTS)}
          >
            <BsClipboardPlus size={24} />
          </IconButton>
        </div>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
          onChange={handleFileChange}
        />

        <Table columns={columns(handleDelete, handleEdit)} data={documents} loading={loading} showIndex />

        <Pagination
          totalPages={totalPages}
          page={page}
          onPageChange={onChangePage}
        />
      </section>
    </main>
  );
}

export default Indicators;
